import { render } from "./MediaImported.vue?vue&type=template&id=05ff46f6"
import script from "./MediaImported.vue?vue&type=script&lang=js"
export * from "./MediaImported.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__